import { render, staticRenderFns } from "./round.vue?vue&type=template&id=5d0a54c8&scoped=true"
import script from "./round.vue?vue&type=script&lang=js"
export * from "./round.vue?vue&type=script&lang=js"
import style0 from "./round.vue?vue&type=style&index=0&id=5d0a54c8&prod&scoped=true&lang=css"
import style1 from "./round.vue?vue&type=style&index=1&id=5d0a54c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0a54c8",
  null
  
)

export default component.exports